import { init as nl__init } from "./init.js";
import { init as lenis__init } from "./modules/lenis.js";
import { init as barba__init } from "./modules/barba.js";
import { init as hooks__init } from "./modules/hooks.js";

// Swiper Styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


// Check if we are in the WordPress admin or block editor
const isAdmin = document.body.classList.contains('wp-admin') || document.body.classList.contains('block-editor-page') || document.querySelector('.edit-post-layout');

if (!isAdmin) {
    hooks__init();
    barba__init();
    lenis__init();
}


jQuery(function () {
    //console.log('jQuery first time');
    nl__init();
});
